// getTranslationLabelColumns.ts
import React from "react";
import { GridColDef } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import { typeColumn } from "./TypeCellRenderer";
import { contextColumn } from "./ContextCellRenderer";
import { sourceValueColumn } from "./SourceValueCellRenderer";
import TargetValueCellRenderer from "./TargetValueCellRenderer";
import TargetValueEditCellRenderer from "./TargetValueEditCellRenderer";
import { Label } from "../../../model/Label";
import { statusColumn } from "./StatusCellRenderer";
import { actionsColumn } from "./ActionsCellRenderer";

export const getTranslationLabelHiddenColumns = (): string[] => ["id", "modifiedAt", "technicalContext", "type", "context"];

export const getTranslationLabelColumns = (
  onSave: (label: Label, forceMode?: boolean) => Promise<void>,
  targetLanguageCode?: string
): GridColDef[] => [
  {
    field: "id",
    headerName: "ID",
    width: 80,
    minWidth: 70,
    headerClassName: "labels-table--header",
  },
  typeColumn,
  contextColumn,
  {
    field: "technicalContext",
    headerName: "Technical context",
    flex: 1,
  },
  sourceValueColumn,
  {
    field: "targetValue",
    headerName: "Translation",
    flex: 1.2,
    width: 220,
    minWidth: 220,
    editable: true,
    hideable: false,
    headerClassName: "labels-table--header",
    renderHeader: () => (
      <div className="flex items-center gap-1">
        <Typography variant="subtitle2" fontWeight="medium">
          Translation
        </Typography>
        {targetLanguageCode && (
          <div className="px-1.5 py-0.5 bg-green-100 text-green-800 rounded text-xs font-medium">
            {targetLanguageCode.toUpperCase()}
          </div>
        )}
      </div>
    ),
    renderCell: (params) => TargetValueCellRenderer(params),
    renderEditCell: (params) => (
      <TargetValueEditCellRenderer params={params} onSave={onSave} />
    ),
  },
  statusColumn,
  //actionsColumn, remove the comment when the feature will be developped
  {
    field: "modifiedAt",
    headerName: "Modified at",
  },
];
